import React, { useCallback, useEffect, useMemo, useState } from "react";

import {handleActive, handleDelete, handleInactive, handleRevive } from "utils/UserUtils";

import CheckboxButton from "components/common/CheckboxButton";
import CustomButton from "components/common/CustomButton";
import PaginationDataTable from "components/common/PaginationDataTable";
import PageHeading from "components/common/PageHeading";
import { UPDATE_BRAND_KEY_VALUE_PAIRS } from "reducer/actions";
import { useDispatch } from "react-redux";
import { toast } from "react-hot-toast";
import { API_SUCCESS } from "api/ResponseCodes";
import { callPostApi } from "api/ApiCaller";
import dateUtilities from "utils/DateUtilities";
import { Activate_Restaurant_Payment_Mode_PUT, All_Restaurant_Payment_Mode_List_POST, DeActivate_Restaurant_Payment_Mode_PUT, Delete_Restaurant_Payment_Mode_DELETE, Deleted_Restaurant_Payment_Mode_List_POST, Key_Value_List_Restaurant_Payment_Mode_POST, Revive_Restaurant_Payment_Mode_PUT, Update_Restaurant_Payment_Mode_PUT } from "api/ApiConst";
import RestaurantAggregatorAddEdit from "./RestaurantPaymentModeAddEdit";
import RestaurantPaymentModeAddEdit from "./RestaurantPaymentModeAddEdit";

const RestaurantPaymentModeMaster = () => {
    const dispatch = useDispatch();
    const [refreshFlag, setRefreshFlag] = useState(0);
    const [viewDeletedList, setViewDeletedList] = useState(false);
    const [recordID, setRecordID] = useState(null);
    const [showAddUpdateModal, setShowAddUpdateModal] = useState(false);

    useEffect(() => {
        if (!showAddUpdateModal) {
            setRecordID(null);
        }
    }, [showAddUpdateModal]);

    const handleRefresh = useCallback(() => {
        const rUrl = Key_Value_List_Restaurant_Payment_Mode_POST;
        const rObj = {};
        callPostApi(null, rUrl, rObj, {}, (response) => {
            if (response.errorCode === API_SUCCESS) {
                dispatch({ type: Update_Restaurant_Payment_Mode_PUT, payload: response.responsePacket })
            } else {
                toast.error(response.message);
            }
        });
        setRefreshFlag(refreshFlag + 1);
    }, [refreshFlag]);

    const columns = useMemo(
        () => [
            {
                id: "status",
                name: "",
                selector: (row) => <div className={row.active ? "led-green" : "led-red"} title={row.active ? "Active" : "Inactive"} />,
                width: "60px",
                sortable: false,
            },
            {
                id: " Title",
                name: " Title Name",
                selector: (row) => row.title,
                sortable: false,
            },
            {
                id: "createdAt",
                name: "Created Time",
                selector: (row) => dateUtilities.formattedDate(row.createdAt, "dd-MM-yyyy, hh:mm aa"),
                sortable: false,
            },
            {
                id: "action",
                name: "",
                selector: (row) => getActionButtons(row),
                width: "80px",
                sortable: false,
            },
        ],
        [handleRefresh]
    );

    const getActionButtons = (row) => {
        return (
            <div className="d-flex align-items-center justify-content-between">
                {!row.deleted && (
                    <button className="listBtn me-2" onClick={() => handleEdit(row)}>
                        <i className="bx bx-pencil"></i>
                    </button>
                )}
                <div className="dropdown">
                    <button className="btn btn-primary btn-flat btn-addon btn-xs dropdown-toggle" title="More" data-bs-toggle="dropdown" aria-expanded="false" style={{ padding: "5px 10px 8px 10px" }}>
                        <i className="bx bx-chevron-down"></i>
                    </button>
                    <ul className="dropdown-menu dropdown-menu-right">
                        <>
                            {row.deleted ? (
                                <li onClick={() => handleReviveData(row)}>
                                    <i className="bx bx-log-out-circle"></i> Revive
                                </li>
                            ) : (
                                <>
                                    <li onClick={() => handleDeleteData(row)}>
                                        <i className="bx bx-trash"></i> Delete
                                    </li>
                                    <li onClick={() => handleActiveInactive(row)}>
                                        {row.active ? (
                                            <>
                                                <i className="bx bx-x-circle"></i> Inactive
                                            </>
                                        ) : (
                                            <>
                                                <i className="bx bx-check-circle"></i> Active
                                            </>
                                        )}
                                    </li>
                                </>
                            )}
                        </>
                    </ul>
                </div>
            </div>
        );
    };

    const handleEdit = (row) => {
        setRecordID(row.uuid);
        setShowAddUpdateModal(true);
    };

    const handleActiveInactive = (row) => {
        if (row.active) {
            handleInactive(DeActivate_Restaurant_Payment_Mode_PUT.replaceAll("{recordID}", row.uuid), handleRefresh);
        } else {
            handleActive(Activate_Restaurant_Payment_Mode_PUT.replaceAll("{recordID}", row.uuid), handleRefresh);
        }
    };

    //Delete Record
    const handleDeleteData = (row) => {
        handleDelete(Delete_Restaurant_Payment_Mode_DELETE.replaceAll("{recordID}", row.uuid), handleRefresh);
    };

    //Revive Record
    const handleReviveData = (row) => {
        handleRevive(Revive_Restaurant_Payment_Mode_PUT.replaceAll("{recordID}", row.uuid), handleRefresh);
    };

    const handleToggleDeletedView = () => setViewDeletedList(!viewDeletedList);

    return (
        <>
            {PageHeading("Payment Mode List", "Dashboard", "/")}
            <div className="card">
                <CustomButton handleClick={() => setShowAddUpdateModal(true)} title="Create New" iconClass="bx bx-plus" buttonClass="createButton" />
                <div className="card-body tableView">
                    <PaginationDataTable
                        paginationUrl={viewDeletedList ? Deleted_Restaurant_Payment_Mode_List_POST : All_Restaurant_Payment_Mode_List_POST}
                        serverSidePagination={true}
                        search={true}
                        pagination={false}
                        columns={columns}
                    />
                    <CheckboxButton title="Deleted List" handleClick={handleToggleDeletedView} additionalClass="deletedBtn ml-auto" />
                </div>
            </div>
            {showAddUpdateModal && <RestaurantPaymentModeAddEdit show={showAddUpdateModal} hideModal={() => setShowAddUpdateModal(false)} recordID={recordID} handleRefresh={handleRefresh} />}
        </>
    );
};

export default RestaurantPaymentModeMaster